var stackObjects=[];
var  allfunctions={
    set:function(obj,name){
        stackObjects[name]=obj;
    }
    ,get:function(name){
        if(stackObjects[name]){
            return stackObjects[name];
        }else{
             console.log("stackObjects:");
             console.log(stackObjects);
             alert("No existe el  objeto = "+name);
        }
        
    }
}